import React from "react";

export default function CSS() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="css">
      <path fill="#2196F3" d="m1 0 1.275 14.4L8 16l5.723-1.599L15 0z"></path>
      <path
        fill="#FAFAFA"
        d="m12.274 4.709-.161 1.809-.486 5.423L8 12.944l-.003.001-3.625-1.004-.253-2.836h1.776l.132 1.471 1.971.532.001-.001 1.974-.532.269-2.451-6.208.017-.176-1.676 6.533-.077.132-1.794-6.84.019-.115-1.669h8.864z"
      ></path>
    </svg>
  );
}
